module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card-title', {
    staticClass: "sub-title ma-0 pa-0"
  }, [_vm._v("\n        Average Summary\n      ")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md2": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Activating")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.activating) + " days")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md2": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Pairing")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.pairing) + " days")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md2": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Cocreating")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.cocreating) + " days")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Complete")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.complete) + " days")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Average Duration")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.duration) + " days")])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82e88152"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/Timeline/Summary/AverageBoxes.vue
// module id = 2229
// module chunks = 0